import {
  UIAppContent,
  UIAppSidebar,
  SidebarButtonLogo,
  SidebarButton,
  SidebarBottom,
  SidebarUserMenu,
  useTheme,
  Topbar,
  UIContentMain,
  UIContentTopbar,
} from "@eventsquare/uikit";
import {
  RiSettings3Line,
  RiSunLine,
  RiMoonLine,
  RiHomeLine,
  RiFileList3Line,
} from "@remixicon/react";
import { Outlet } from "react-router-dom";
import styles from "./AppLayout.module.scss";
import { Link } from "react-router-dom";
import { AppContext, AppContextInterface } from "@context/appContext";
import { useCallback, useEffect, useState } from "react";
import { Product } from "@type/products";
import { Cart } from "@type/carts";
import dummyProds from "@/data/dummyProducts.json";
import categories from "@/data/dummyCategories.json";
import PaymentModal from "@components/PaymentModal/PaymentModal";

const AppLayout = () => {
  const [products, setProducts] = useState<Product[] | null>(null);
  const [cart, setCart] = useState<Cart>([]);
  const [activeCategory, setActiveCategory] = useState<string | undefined>(
    undefined
  );
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  const handleToggleTheme = () => {
    setColorMode(colorMode === "light" ? "dark" : "light");
  };
  const { colorMode, setColorMode } = useTheme();

  const addToCart = useCallback((productUID: string) => {
    setCart((prevCart) => {
      const existingItem = prevCart.find((item) => item.uid === productUID);
      if (existingItem) {
        return prevCart.map((item) =>
          item.uid === productUID
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
      return [...prevCart, { uid: productUID, quantity: 1 }];
    });
  }, []);

  const removeFromCart = useCallback((productUID: string) => {
    setCart((prevCart) => {
      const existingItem = prevCart.find((item) => item.uid === productUID);
      if (!existingItem) return prevCart;

      if (existingItem.quantity > 1) {
        return prevCart.map((item) =>
          item.uid === productUID
            ? { ...item, quantity: item.quantity - 1 }
            : item
        );
      }
      return prevCart.filter((item) => item.uid !== productUID);
    });
  }, []);

  const clearCart = useCallback((productUID?: string) => {
    if (!productUID) {
      setCart([]);
      return;
    }
    setCart((prevCart) => prevCart.filter((item) => item.uid !== productUID));
  }, []);

  const fetchProducts = useCallback(async () => {
    try {
      setProducts(dummyProds as Product[]);
    } catch (error) {
      console.error("Error fetching products:", error);
      setProducts([]);
    }
  }, []);

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);
  return (
    <AppContext.Provider
      value={
        {
          add: addToCart,
          remove: removeFromCart,
          clear: clearCart,
          cart,
          products: products || [],
          categories,
          setActiveCategory,
          activeCategory,
          setShowPaymentModal,
          showPaymentModal,
          totalPrice: cart
            .reduce((total, item) => {
              const product = products?.find((prod) => prod.uid === item.uid);
              return total + (product ? product.price * item.quantity : 0);
            }, 0)
            .toFixed(2),
        } satisfies AppContextInterface
      }
    >
      <div className={styles.appLayout}>
        <UIAppSidebar>
          <Link to="/">
            <SidebarButtonLogo />
          </Link>
          <Link to="/">
            <SidebarButton icon={RiHomeLine} label="Dashboard" />
          </Link>
          <Link to="/orders">
            <SidebarButton
              icon={RiFileList3Line}
              label="Orders Overview"
              active={location.pathname === "/orders"}
            />
          </Link>
          <Link to="/settings">
            <SidebarButton
              icon={RiSettings3Line}
              label="Settings"
              active={location.pathname === "/settings"}
            />
          </Link>
          <SidebarBottom>
            <SidebarUserMenu
              translations={{
                switch_account: "test",
                logout: "test",
                change_avatar: "test",
                switch_language: "test",
                languages: {
                  nl: "test",
                  en: "test",
                  fr: "test",
                },
              }}
            />
            <SidebarButton
              icon={colorMode === "light" ? RiSunLine : RiMoonLine}
              label={colorMode === "light" ? "test" : "test"}
              onClick={handleToggleTheme}
            />
          </SidebarBottom>
        </UIAppSidebar>
        <UIAppContent>
          <UIContentTopbar>
            <Topbar hideTablet />
          </UIContentTopbar>
          <UIContentMain>
            <Outlet />
          </UIContentMain>
        </UIAppContent>
      </div>
      <PaymentModal
        showModal={showPaymentModal}
        setShowModal={setShowPaymentModal}
      />
    </AppContext.Provider>
  );
};

export default AppLayout;
